import styled from 'styled-components';

export const NoContentOuterWrapper = styled.div`
    display: grid;
    flex-grow: 1;
    align-items: center;
    height: 100%;
    ${({ theme }) => `
        padding: 0 ${theme.spacing(5)}px;
        margin-top: -${theme.toolbar.desktopHeight}px;
    `}
`;

export const NoContentInnerWrapper = styled.div`
    display: grid;
    gap: ${({ theme }) => theme.spacing(2)}px 0;
`;